<template>
    <div class="wrap-input"
        :class="[{'select-mass': theme == 'mass'}, {'select-prestige': theme == 'prestige'}, {'no-top': !label}, customClass]">
        <label class="label"
               :class="{'error': !isFirstSave && isShowErrorLbl && !errorInfo.isValid}"
               v-if="label">
            {{label}}
        </label>
        <div :class="{'input-box-error': !isFirstSave && isShowErrorLbl && !errorInfo.isValid}">
            <b-dropdown :text="textValueDropdown"
                        class="ddl-input custom-ddl-input"
                        variant="ddl-input"
                        menu-class="ddl-menu">
                <b-dropdown-item v-for="(v,k) in dropdownList"
                                 :key="k"
                                 @click="onChange(v)">
                    {{v.text}}
                </b-dropdown-item>
            </b-dropdown>
        </div>
        <div class="error-text"
             v-if="isShowErrorLbl"
             v-show="!isFirstSave && !errorInfo.isValid">
            {{errorInfo.msg}}
        </div>
    </div>
</template>
<script>
import Util from "@/helper/Utility.js";
/**
 * Property
 * @property {Object} inputLbl (required) Text for component.
 * @property {Boolean} isFirstSave (required) Show/Hide Error after save.
 * @property {Boolean} isShowErrorLbl (optional) Show/Hide Error label.
 * @property {Object} errorInfo (optional) Validate result. example : { isValid: true, msg: '',}
 * @property {String} addClass (optional) Add css class.
 * @property {Array} itemList (required) item list in dropdown. example : [{ value: '1', text: 'a'}]
 */
export default {
    name: "Dropdown",
    computed: {
        theme: function () {
            return this.$store.state.theme;
        }
    },
    props: {
        //v-model
        value: String,
        //props
        inputLbl: Object,
        isFirstSave: Boolean,
        isShowErrorLbl: Boolean,
        errorInfo: Object,
        addClass: String,
        itemList: Array,
    },
    data: function() {
        return {
            label: '',
            content: this.value,
            customClass: '',

            textValueDropdown: '',
            dropdownList: [],
        };
    },
    mounted: function() {
        this.label = this.inputLbl.name;
        this.customClass = this.addClass || '';
        this.dropdownList = this.itemList;
        this.textValueDropdown = this.inputLbl.defaultText;
        this.initialDefaultValue();
        this.validateInput();
    },
    methods: {
        initialDefaultValue: function() {
            if (Util.isEmptyStr(this.value)) {
                return;
            }

            for (var i of this.dropdownList) {
                if (i.value == this.value) {
                    this.onChange(i);
                    break;
                }
            }
        },
        validateInput: function() {
            if(!this.inputLbl) return;
            //Set default.
            this.errorInfo.isValid = true;
            this.errorInfo.msg = '';
            //Required
            if(this.inputLbl.required && Util.isEmptyStr(this.content)) {
                this.errorInfo.isValid = false;
                this.errorInfo.msg = this.inputLbl.required;
                return;
            }
        },
        onChange: function(selected) {
            this.content = selected.value;
            this.textValueDropdown = selected.text;

            this.validateInput();
            this.$emit('input', selected.value);
            this.$emit('changeEvent', selected);
        },
    },
}
</script>
<style lang="scss">
    $url-dropdown-icon: url('../../assets/history/mass/ic-mass-dropdown@3x.png');
    $mass-dropdown-icon: url('../../assets/history/mass/ic-mass-dropdown@3x.png');
    $prestige-dropdown-icon: url('../../assets/history/prestige/ic-prestige-dropdown@3x.png');
    @import "@/style/Input/Dropdown.scss";
    @import "@/style/Input/Text.scss";
    @import "@/style/base/base.scss";
    .wrap-input {
        @extend %input-base;
    }

    .custom-ddl-input {
        // font-family: $heading;

        .btn-ddl-input {
            // font-family: $heading;
            text-align: center;
            font-size: 1.25rem;
            padding: 2px 20px;
            border-color:#bcbec0;
            border-radius: 25px;
        }

        .ddl-menu {
            max-height: 340px;
            min-width: 50px;
            overflow: scroll;
            width:100%;
            font-size: 1.2rem;
        }
    }

    .select-mass {
        .custom-ddl-input {
            .btn-ddl-input {
                color: $mass_theme_color;
                background-color: #fff;
                background-image: $mass-dropdown-icon;
                background-repeat: no-repeat;
                background-size: 12px;
                background-position-x: calc(100% - 10px);
                background-position-y: 14px;
            }
        }
    }

    .select-prestige {
        .custom-ddl-input {
            .btn-ddl-input {
                color: $prestige_theme_color;
                background-color: #fff;
                background-image: $prestige-dropdown-icon;
                background-repeat: no-repeat;
                background-size: 12px;
                background-position-x: calc(100% - 10px);
                background-position-y: 14px;
            }
        }
    }
</style>
